import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {ModelDbXrefEntity} from './model.db.xref.entity';

@EntityTable('model_query', '28d44c6a-4afc-481d-ba47-bf9a9d306b2d')
export class ModelQueryEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, ModelDbXrefEntity, false, false, FieldRelationKind.BELONGS_TO, 'modelDbXref', 'aliasId', 'modelDbXrefId')
    public modelDbXrefId: string;

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.BOOLEAN)
    public global: boolean;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Column(FieldTypeKind.ANY)
    public clauses: any;

    @Column(FieldTypeKind.ANY)
    public includes: any[];

    @Column(FieldTypeKind.ANY)
    public sort: any[];

    @Transient()
    public modelDbXref: ModelDbXrefEntity;

    @Transient()
    public attributes: any;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
